import classNames from "classnames";
import { compact } from "lodash";
import Link from "next/link";
import { TabKey } from "pages/brand/[symbol]";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./BrandStickyNav.module.scss";

type Props = {
  onChange: (activeKey: TabKey, clicked?: boolean) => void;
  activeTab: TabKey;
  activeStore?: boolean;
  companyStoreClick: () => void;
};

const BrandStickyNav = (props: Props) => {
  const [sectionsOnScreen, setSectionsOnScreen] = useState<TabKey[]>();

  const checkActiveTab = useCallback(
    (e) => {
      const tabAnchors = document.querySelectorAll<HTMLDivElement>(
        "[data-scroll-anchor]"
      );
      const mappedTabLocations = Array.from(tabAnchors).map((tab) => {
        const dims = tab.getBoundingClientRect();

        return {
          key: tab.id as TabKey,
          dims: dims,
        };
      });

      if (mappedTabLocations.length === 0) {
        return;
      }

      const activeTab = mappedTabLocations
        .filter((tab) => tab.dims.top < 10)
        .reduce(
          (final, current) => {
            if (final.key === null || final.dims === null) {
              return current;
            }

            return current.dims.top > final.dims.top ? current : final;
          },
          { key: null, dims: null } as {
            key: TabKey | null;
            dims: DOMRect | null;
          }
        );

      if (!activeTab) {
        return;
      }

      const key = activeTab.key;
      if (key && Object.keys(TabKey).includes(key)) {
        props.onChange(key, false);
      }
    },
    [props.onChange]
  );

  useEffect(() => {
    const tabAnchors = document.querySelectorAll<HTMLDivElement>(
      "[data-scroll-anchor]"
    );

    const presentSections = compact(
      Array.from(tabAnchors).map((el) =>
        Object.keys(TabKey).includes(el.id) ? (el.id as TabKey) : null
      )
    );
    setSectionsOnScreen(presentSections);

    document.addEventListener("scroll", checkActiveTab);

    return () => {
      document.removeEventListener("scroll", checkActiveTab);
    };
  }, []);

  return (
    <div className={styles.navBar}>
      <div className={classNames(styles.allLinkContainer, "container")}>
        {Object.entries(TabKey).map(([key, value]) => {
          if (value === TabKey.ShareholderStore) {
            if (!props.activeStore) {
              return <></>;
            }

            return (
              <a
                className={classNames(
                  styles.linkContainer,
                  props.activeTab === key ? styles.activeLink : undefined
                )}
                onClick={props.companyStoreClick}
                key={`sub-nav-${key}`}
              >
                <p className={styles.linkText}>{value}</p>
              </a>
            );
          }

          if (!sectionsOnScreen?.includes(key as TabKey)) {
            return <></>;
          }

          return (
            <Link href={`#${key}`}>
              <a
                className={classNames(
                  styles.linkContainer,
                  props.activeTab === key ? styles.activeLink : undefined
                )}
                onClick={() => props.onChange(key as TabKey, true)}
                key={`sub-nav-${key}`}
              >
                <p className={styles.linkText}>{value}</p>
              </a>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BrandStickyNav;
